var render = function render(){var _vm=this,_c=_vm._self._c;return _c('running-join-request-data-table',{attrs:{"allrunningparticipants":_vm.allrunningparticipants}})
}
var staticRenderFns = []

export { render, staticRenderFns }